<template>
  <div>
    <b-row v-if="isEditing">
      <b-col lg="3" md="3" sm="12">
        <b-form-group label="Status" label-for="input-documento">
          <b-form-select
            v-model="model.status"
            id="tablePerPageSelect"
            :options="statusOpt"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Card de origem" label-for="input-documento">
          <b-form-input type="text" v-model="model.originCardId" />
          <b-input-group-append>
            <b-button class="file" @click="openFilledModal"
              ><b-icon icon="eye" aria-hidden="true"></b-icon
            ></b-button>
          </b-input-group-append>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <!-- numeroDocumento -->
        <b-form-group label="Número de documento" label-for="input-documento">
          <b-form-input
            type="text"
            id="input-documento"
            placeholder="Informe o número de documento"
            v-model="model.numeroDocumento"
            v-mask="'99.999.999/9999-99'"
          />
          <span class="text-danger" v-if="modelstate['NumeroDocumento']">
            {{ modelstate["NumeroDocumento"][0] }}
          </span>
        </b-form-group>

        <!-- razaoSocial -->
        <b-form-group label="Razão social" label-for="input-razaoSocial">
          <b-form-input
            type="text"
            id="input-razaoSocial"
            placeholder="Informe a razão social"
            v-model="model.razaoSocial"
          />
          <span class="text-danger" v-if="modelstate['RazaoSocial']">
            {{ modelstate["RazaoSocial"][0] }}
          </span>
        </b-form-group>

        <!-- nomeFantasia -->
        <b-form-group label="Nome fantasia" label-for="input-nomeFantasia">
          <b-form-input
            type="text"
            id="input-nomeFantasia"
            placeholder="Informe o nome fantasia"
            v-model="model.nomeFantasia"
          />
          <span class="text-danger" v-if="modelstate['NomeFantasia']">
            {{ modelstate["NomeFantasia"][0] }}
          </span>
        </b-form-group>

        <!-- branchName -->
        <b-form-group label="Nome da filial" label-for="input-branchName">
          <b-form-input
            type="text"
            id="input-branchName"
            placeholder="Informe o nome da filial"
            v-model="model.branchName"
          />
          <span class="text-danger" v-if="modelstate['BranchName']">
            {{ modelstate["BranchName"][0] }}
          </span>
        </b-form-group>
      </b-col>
      <b-col lg="6" md="6" sm="12">
        <!-- telefoneComercial -->
        <b-form-group
          label="Telefone comercial"
          label-for="input-telefoneComercial"
        >
          <b-form-input
            type="text"
            id="input-telefoneComercial"
            placeholder="Informe o telefone comercial"
            v-model="model.telefoneComercial"
            v-mask="'(99) 9999-9999'"
          />
          <span class="text-danger" v-if="modelstate['TelefoneComercial']">
            {{ modelstate["TelefoneComercial"][0] }}
          </span>
        </b-form-group>

        <!-- celular -->
        <b-form-group label="Celular" label-for="input-celular">
          <b-form-input
            type="text"
            id="input-celular"
            placeholder="Informe o celular da empresa"
            v-model="model.celular"
            v-mask="'(99) 99999-9999'"
          />
          <span class="text-danger" v-if="modelstate['Celular']">
            {{ modelstate["Celular"][0] }}
          </span>
        </b-form-group>

        <!-- email -->
        <b-form-group label="E-mail" label-for="input-email">
          <b-form-input
            type="email"
            id="input-email"
            placeholder="Informe o e-mail da empresa"
            v-model="model.email"
          />
          <span class="text-danger" v-if="modelstate['Email']">
            {{ modelstate["Email"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- dados do cliente -->
    <div class="mt-3">
      <h3>Plano</h3>
      <b-row>
        <b-col cols="3">
          <b-form-group label="Voucher" label-for="input-documento">
            <b-form-input
              type="text"
              id="input-documento"
              placeholder="Informe o número de documento"
              v-model="model.voucher"
            />
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Plano" label-for="input-documento">
            <b-form-select
              v-model="model.planId"
              :options="planOpt"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <!-- {{ model.startPlan }} -->
          <b-form-group label="Início" label-for="input-documento">
            <b-form-input type="date" v-model="model.startPlan" />
            <span class="text-danger" v-if="modelstate['StartPlan']">
              {{ modelstate["StartPlan"][0] }}
            </span>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Fim" label-for="input-documento">
            <b-form-input type="date" v-model="model.endPlan" />
            <span class="text-danger" v-if="modelstate['EndPlan']">
              {{ modelstate["EndPlan"][0] }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <b-form-group label="Valor" label-for="input-documento">
            <b-form-input
              v-model="model.planValue"
              type="text"
              id="name"
              v-mask="'money'"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Quantidade de veículos"
            label-for="input-documento"
          >
            <b-form-input
              v-model="model.qntVehicle"
              type="number"
              id="name"
              v-mask="'999999999999999'"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group
            label="Quantidade de preenchimentos"
            label-for="input-documento"
          >
            <b-form-input
              v-model="model.fanchise"
              type="number"
              id="name"
              v-mask="'999999999999999'"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <b-form-group label="País" label-for="input-documento">
            <b-form-select
              v-model="model.countryId"
              :options="countryOpt"
              @change="getAllStates(model.countryId)"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Estado" label-for="input-documento">
            <b-form-select
              v-model="model.stateId"
              :options="stateOpt"
              @change="getAllCities(model.stateId)"
              :disabled="disableState"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-form-group label="Cidade" label-for="input-documento">
            <b-form-select
              v-model="model.cityId"
              :options="cityOpt"
              :disabled="disableCity"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <!-- Gerenciamento de acesso -->

    <div v-if="$store.state.adminRms" class="mt-3">
      <h3>Gerenciamento de acesso</h3>
      <b-row>
        <b-col lg="6" md="6" sm="12">
          <!-- adminUsername -->
          <b-form-group
            label="Usuário administrador"
            label-for="input-adminUsername"
          >
            <b-form-input
              type="text"
              id="input-adminUsername"
              placeholder="Usuário administrador"
              v-model="model.adminUsername"
            />
            <span class="text-danger" v-if="modelstate['AdminUsername']">
              {{ modelstate["AdminUsername"][0] }}
            </span>
          </b-form-group>

          <!-- adminPassword -->
          <b-form-group
            label="Senha administrador"
            label-for="input-adminPassword"
          >
            <b-form-input
              type="text"
              id="input-adminPassword"
              placeholder="Senha administrador"
              v-model="model.adminPassword"
            />
            <span class="text-danger" v-if="modelstate['AdminPassword']">
              {{ modelstate["AdminPassword"][0] }}
            </span>
          </b-form-group>
        </b-col>
        <b-col>
          <!-- Tema -->
          <b-form-group label="Tema" label-for="select-companyTheme">
            <b-form-select :options="options" v-model="model.companyTheme" />

            <span class="text-danger" v-if="modelstate['companyTheme']">
              {{ modelstate["companyTheme"][0] }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div>
      <b-row class="mt-3">
        <b-col md="3">
          <!-- Tipo de empresa -->
          <b-form-group label="Tipo de empresa" label-for="tipoEmpresa">
            <!-- Embarcador -->
            <b-form-checkbox
              id="tipoEmbarcador"
              v-model="model.embarcador"
              :value="true"
              :unchecked-value="false"
            >
              Embarcador
            </b-form-checkbox>
            <span class="text-danger" v-if="modelstate['Embarcador']">
              {{ modelstate["Embarcador"][0] }}
            </span>

            <!-- Transportador -->
            <b-form-checkbox
              class="mt-3"
              id="tipoTransportador"
              v-model="model.transportador"
              :value="true"
              :unchecked-value="false"
            >
              Transportador
            </b-form-checkbox>
            <span class="text-danger" v-if="modelstate['Transportador']">
              {{ modelstate["Transportador"][0] }}
            </span>
          </b-form-group>
        </b-col>

        <b-col>
          <b-row>
            <label class="ml-3"> Módulos </label>
          </b-row>
          <b-row>
            <b-col>
              <!-- Checklist -->
              <b-form-checkbox
                id="modulos"
                v-model="model.checklist"
                :value="true"
                :unchecked-value="false"
              >
                Checklist
              </b-form-checkbox>
              <span class="text-danger" v-if="modelstate['Checklist']">
                {{ modelstate["Checklist"][0] }}
              </span>
            </b-col>
            <b-col>
              <!-- Workflow -->
              <b-form-checkbox
                id="workflow"
                v-model="model.workflow"
                :value="true"
                :unchecked-value="false"
              >
                Workflow
              </b-form-checkbox>
              <span class="text-danger" v-if="modelstate['workflow']">
                {{ modelstate["workflow"][0] }}
              </span>
            </b-col>
            <b-col>
              <!-- Plano de viagem -->
              <b-form-checkbox
                id="planoViagem"
                v-model="model.planoDeViagem"
                :value="true"
                :unchecked-value="false"
              >
                Plano de Viagem
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <!-- BI -->
              <b-form-checkbox
                class="mt-3"
                id="bi"
                v-model="model.bi"
                :value="true"
                :unchecked-value="false"
              >
                BI
              </b-form-checkbox>
              <span class="text-danger" v-if="modelstate['BI']">
                {{ modelstate["BI"][0] }}
              </span>
            </b-col>
            <b-col md="8">
              <!-- Tracking -->
              <b-form-checkbox
                class="mt-3"
                id="tracking"
                v-model="model.tracking"
                :value="true"
                :unchecked-value="false"
              >
                Tracking
              </b-form-checkbox>
              <span class="text-danger" v-if="modelstate['Tracking']">
                {{ modelstate["Tracking"][0] }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <!-- FuelSupply -->
              <b-form-checkbox
                class="mt-3"
                id="FuelSupply"
                v-model="model.fuelSupply"
                :value="true"
                :unchecked-value="false"
              >
                Abastecimento
              </b-form-checkbox>
              <span class="text-danger" v-if="modelstate['FuelSupply']">
                {{ modelstate["FuelSupply"][0] }}
              </span>
            </b-col>
            <b-col>
              <!-- FuelSupplyHorimeter -->
              <b-form-checkbox
                class="mt-3"
                id="FuelSupplyHorimeter"
                v-model="model.fuelSupplyHorimeter"
                :value="true"
                :unchecked-value="false"
              >
                Abastecimento Horimetro
              </b-form-checkbox>
              <span
                class="text-danger"
                v-if="modelstate['FuelSupplyHorimeter']"
              >
                {{ modelstate["FuelSupplyHorimeter"][0] }}
              </span>
            </b-col>
            <b-col>
              <!-- Revision -->
              <b-form-checkbox
                class="mt-3"
                id="Revision"
                v-model="model.revision"
                :value="true"
                :unchecked-value="false"
              >
                Revisão
              </b-form-checkbox>
              <span class="text-danger" v-if="modelstate['Revision']">
                {{ modelstate["Revision"][0] }}
              </span>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="3">
          <!-- Qualidade da imagem -->
          <b-form-group label="Qualidade da imagem" label-for="imageQuality">
            <!-- Qualidade Padrão(480P) -->
            <b-form-checkbox
              id="imageQuality"
              v-model="model.imageQuality"
              :value="0"
              :unchecked-value="1"
            >
              480P
            </b-form-checkbox>
            <!-- Qualidade Alta(1080P) -->
            <b-form-checkbox
              class="mt-3"
              id="imageQuality"
              v-model="model.imageQuality"
              :value="1"
              :unchecked-value="0"
            >
              1080P
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col cols="3">
          <!-- Mecanismo de Anexos -->
          <b-form-group label="Mecanismo de Anexos" label-for="AllowVideo">
            <!-- Permite video -->
            <b-form-checkbox id="AllowVideo" v-model="model.allowVideo">
              Vídeo
            </b-form-checkbox>

            <!-- Permite documento -->
            <b-form-checkbox
              class="mt-3"
              id="AllowDocuments"
              v-model="model.allowDocuments"
            >
              Documentos
            </b-form-checkbox>

            <!-- Permite OCR -->
            <b-form-checkbox
              class="mt-3"
              id="AllowOCR"
              v-model="model.allowOcr"
            >
              OCR
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col cols="3">
          <!-- Nível de compressão -->
          <b-form-group
            label="Nível de compressão"
            label-for="CompressionLevel"
          >
            <b-form-input
              id="compressionLevel"
              v-model="model.compressionLevel"
              type="range"
              min="10"
              max="100"
            ></b-form-input>
            <span :style="typeColor()">
              {{ statusQuality() }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="3">
          <!-- Map Engine -->
          <b-form-group label="Mecanismo do Mapa" label-for="OpenStreet">
            <!-- OpenStreet -->
            <b-form-checkbox
              class="mt-3"
              id="OpenStreet"
              v-model="model.mapEngine"
              :value="0"
              :unchecked-value="1"
            >
              OpenStreet
            </b-form-checkbox>

            <!-- Google Maps -->
            <b-form-checkbox
              class="mt-3"
              id="GoogleMaps"
              v-model="model.mapEngine"
              :value="1"
              :unchecked-value="0"
            >
              Google Maps
            </b-form-checkbox>

            <!-- API KEY google-->
            <b-form-group
              class="mt-3"
              v-if="model.mapEngine === 1"
              label="API Key do Google Maps"
              label-for="input-googleApiKey"
            >
              <b-form-input
                type="text"
                id="input-googleApiKey"
                placeholder="Insira sua API Key"
                v-model="model.googleApiKey"
              ></b-form-input>
            </b-form-group>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <!-- MFA -->
          <b-form-group
            label="Autenticação em dois fatores (MFA)"
            label-for="OpenStreet"
          >
            <b-form-checkbox
              class="mt-3"
              v-model="model.mfaRequired"
              :value="false"
              :unchecked-value="true"
            >
              Inativada
            </b-form-checkbox>

            <b-form-checkbox
              class="mt-3"
              v-model="model.mfaRequired"
              :value="true"
              :unchecked-value="false"
            >
              Ativada
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <!-- Rascunhos -->
          <b-form-group
            label="Rascunhos"
            label-for="AllowInactiveDraftFilter"
          >
            <b-form-checkbox
              id="AllowInactiveDraftFilter"
              v-model="model.allowInactiveDraftFilter"
            >
              Permitir filtrar rascunhos inativos
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="mb-3 mt-3">
      <div>
        <label>{{ $t("company.logo") }}</label>
        <span> ({{ $t("company.logoBestSize") }})</span>
      </div>
      <b-row class="text-center" v-if="model.logoContent">
        <b-col md="3">
          <base-attachment-item
            :attachment="model.logoContent"
            :discard-visible="true"
            @discard="fileRemove"
          >
          </base-attachment-item>
        </b-col>
      </b-row>
      <div v-else class="mt-0">
        <label>{{ $t("company.logoUndefined") }}</label>
      </div>

      <div>
        <camera-button
          :lang="$i18n.locale"
          :label="getLabelLogoButton()"
          :originObject="model"
          @update-image-src="updateImageSrc"
        >
        </camera-button>
      </div>
    </div>

    <FilledModal ref="filledModal" />
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
import CameraButton from "@/components_rms/CameraButton.vue";

export default {
  name: "Create",
  components: {
    "base-attachment-item": BaseAttachmentItem,
    "camera-button": CameraButton,
    FilledModal: () =>
      import("@/components_rms/workflow/WorkflowFilled/Filled/FilledModal.vue"),
  },
  props: {
    model: Object,
    modelstate: Object,
    isEditing: Boolean,
  },
  data: function () {
    return {
      sucesso: false,
      options: [
        // Tema RMS:
        { value: null, text: "Padrão" },
        { value: "AMAGGI", text: "Amaggi" },
        { value: "EGLOG", text: "EgLog" },
      ],
      planOpt: [],
      countryOpt: [],
      stateOpt: [{ value: null, text: "Selecione um país" }],
      cityOpt: [{ value: null, text: "Selecione um estado" }],
      statusOpt: [
        { value: 1, text: "Ativo" },
        { value: 2, text: "Inativo" },
        { value: 3, text: "Bloqueado" },
      ],
    };
  },
  computed: {
    disableState() {
      if (this.model.countryId != null) return false;
      return true;
    },
    disableCity() {
      if (this.model.stateId != null) return false;
      return true;
    },
  },
  directives: {
    mask: AwesomeMask,
  },
  created() {
    this.getAllPlans();
    this.getAllCountries();
    if (this.model.countryId) {
      this.getAllStates(this.model.countryId);
      this.getAllCities(this.model.stateId);
    }
  },
  methods: {
    openFilledModal() {
      this.$refs.filledModal.openModal(this.model.originCardId);
    },
    getAllPlans() {
      this.$apiScheduler
        .get("/plan/getAllPlans")
        .then((response) => {
          this.planOpt = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllCountries() {
      this.$apiScheduler
        .get("/system/country")
        .then((response) => {
          this.countryOpt = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllStates(country) {
      this.$apiScheduler
        .get("/system/state/" + country)
        .then((response) => {
          this.stateOpt = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getAllCities(state) {
      this.$apiScheduler
        .get("/system/city/" + state)
        .then((response) => {
          this.cityOpt = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getLabelLogoButton() {
      if (!this.model) return this.$t("company.logoAdd");
      if (!this.model.logoContent) return this.$t("company.logoAdd");
      return this.$t("company.logoAlter");
    },
    updateImageSrc(originObject, newValue) {
      this.model.logoContent = newValue;
      this.$forceUpdate();
    },
    fileRemove() {
      this.model.logoContent = null;
      this.$forceUpdate();
    },
    typeColor() {
      let compressionLevel = this.model.compressionLevel;
      if (this.$store.getters.darkmode == true) {
        if (compressionLevel < 40) {
          return "color: #fd5d93";
        } else if (compressionLevel >= 40 && compressionLevel <= 80) {
          return "color: #778899";
        } else if (compressionLevel > 80) {
          return "color: lawngreen";
        }
      } else {
        if (compressionLevel < 40) {
          return "color: #fd5d93";
        } else if (compressionLevel >= 40 && compressionLevel <= 80) {
          return "color: #778899";
        } else if (compressionLevel > 80) {
          return "color: green";
        }
      }
    },
    statusQuality() {
      let compressionLevel = this.model.compressionLevel;
      if (compressionLevel < 40) {
        return `${compressionLevel} Baixa qualidade`;
      } else if (compressionLevel >= 40 && compressionLevel <= 80) {
        return `${compressionLevel} Média Qualidade`;
      } else if (compressionLevel > 80) {
        return `${compressionLevel} Alta qualidade`;
      }
    },
  },
};
</script>
<style scoped>
.file {
  position: absolute;
  width: 20%;
  height: 56%;
  margin-left: 85%;
  margin-top: -38px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>
